import { render, staticRenderFns } from "./MediaUploader.vue?vue&type=template&id=4a23382c&"
import script from "./MediaUploader.vue?vue&type=script&lang=js&"
export * from "./MediaUploader.vue?vue&type=script&lang=js&"
import style0 from "./MediaUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports